'use strict';

var _ = require('lodash');
var FlightAnalysisToggleController = function FlightAnalysisToggleController($rootScope, $scope) {
  var MODE_FLIGHT_ANALYSIS = 'flight-analysis';
  var MODE_FLIGHT_MANAGEMENT = 'flight-management';
  $scope.toggleModes = {};
  $scope.toggleModes[MODE_FLIGHT_ANALYSIS] = {
    label: 'Flight Analysis',
    value: MODE_FLIGHT_ANALYSIS,
    selected: true,
    disabled: false
  };
  $scope.toggleModes[MODE_FLIGHT_MANAGEMENT] = {
    label: 'Flight Mgmt',
    value: MODE_FLIGHT_MANAGEMENT,
    selected: false,
    disabled: false
  };
  $scope.toggleMode = function (currentMode) {
    _.forEach($scope.toggleModes, function (mode) {
      mode.selected = false;
    });
    $scope.toggleModes[currentMode].selected = true;
    $scope.toggleModes[currentMode].disabled = false;
    $scope.toggleFlightAnalysisMode(currentMode);
  };
  function isFlightAnalysisModeSelected() {
    return $scope.toggleModes[MODE_FLIGHT_ANALYSIS].selected;
  }
  function disableToggle() {
    if (isFlightAnalysisModeSelected()) {
      $scope.loading = true;
    }
  }
  function enableToggle() {
    if (isFlightAnalysisModeSelected()) {
      $scope.loading = false;
    }
  }
  $rootScope.$on('loading:progress', disableToggle);
  $rootScope.$on('loading:finish', enableToggle);
};
FlightAnalysisToggleController.$inject = ['$rootScope', '$scope'];
module.exports = FlightAnalysisToggleController;